import React from 'react';

import * as S from './Title.styles';

const Title = ({title, subTitle, customClass}) => {
  return (
    <S.Heading className={customClass || ''}>
      {title} {subTitle && <span>{subTitle}</span>}
    </S.Heading>
  );
};

export default Title;
